import { Component, OnInit } from '@angular/core';

import { ApiConstants } from '@login/api-constants';
import { NavigationService } from '@login/services/navigation.service';
import { HarpLoginService } from '@login/services/harp-login.service';
import { SessionService } from '@shared/services/session.service';
import { AlertService } from '@shared/services/alert.service';

import { OktaAuth } from '@okta/okta-auth-js';

@Component({
  selector: 'app-ado-logout',
  templateUrl: './ado-logout.component.html',
  styleUrls: ['./ado-logout.component.scss'],
})
export class AdoLogoutComponent implements OnInit {
  oktaAuthClient: OktaAuth;
  constructor(
    private sessionService: SessionService,
    private navigationService: NavigationService,
    private alertService: AlertService,
    private harpLoginService: HarpLoginService,
  ) {}

  ngOnInit() {
    this.logout();
  }

  logout() {
    console.log('ado-logout triggered');
    const issuer = this.sessionService.getIssuer();
    this.oktaAuthClient = new OktaAuth({ issuer });
    this.oktaAuthClient
      .closeSession()
      .then(() => {
        console.log('ado-logout signout inside then');
        this.sessionService.logoutHarpSession().subscribe(
          () => {
            console.log(
              'ado-logout inside subscribe: window.location val: ',
              window.location,
            );
            if (!window.location.search) {
              this.navigationService.goToLoginScreen();
            } else {
              const urlParams = new URL(window.location.toString())
                .searchParams;
              const adoName = urlParams.get('ADO');
              const redirectUrl = `${window.location.protocol}//${window.location.host}/login?ADO=${adoName}`;
              window.location.href = redirectUrl;
            }
          },
          err => {
            console.log('ado-logout logoutHarpSession subscribe error: ', err);
          },
        );
      })
      .catch(e => {
        console.log('ado-logout error caught: ', e);
        this.alertService.setAlert(ApiConstants.MSG_LOGOUT_FAILURE);
      });
  }
}
